import { MetypeCommentingWidget } from "@metype/components";
import get from "lodash/get";
import { object } from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

const generateHostUrl = (story = {}) => {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
};

export const CommentingWidget = () => {
  const story = useSelector((state) => get(state, ["qt", "data", "story"], {}));
  const metypeConfig = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}));
  const { metypeHost = "", metypeAccountId = "", primaryColor = "", fontColor = "", className } = metypeConfig;
  return (
    <MetypeCommentingWidget
      host={metypeHost}
      accountId={metypeAccountId}
      pageURL={generateHostUrl(story)}
      primaryColor={primaryColor}
      fontColor={fontColor}
      className={className}
    />
  );
};

CommentingWidget.propTypes = {
  metypeConfig: object,
  story: object,
};
